<template>
  <div id="app">
    <a-spin :spinning="getLoading">
      <a-config-provider :locale="localData[locale]">
        <router-view />
      </a-config-provider>
    </a-spin>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import koKR from 'ant-design-vue/lib/locale-provider/ko_KR';
import jaJP from 'ant-design-vue/lib/locale-provider/ja_JP';
export default {
  data() {
    return {
      locale: localStorage.getItem('lang') || 'en-US',
      localData: {
        'zh-CN': zhCN,
        'en-US': enUS,
        'ko-KP': koKR,
        'ja-JP': jaJP,
      }
    }
  },
  computed: {
    getLoading() {
      return this.$store.state.loading
    }
  },
  created() {
    // // console.log('localData[locale] :>> ', this.localData[this.locale]);

    // this.$message.error({
    //   content: '1',
    //   duration: 100000
    // })

    const token = localStorage.getItem('token');
    if (token) {
      this.$store.dispatch('storeActionUserInfo');
      this.$store.dispatch('storeActionAssetsList');
      // this.$store.dispatch('storeActionReturnWallet');
      // this.$store.dispatch("storeSocketConnect");
    }

  }
}
</script>

<style lang="scss">
@import "./assets/styles/tokens.scss";
@import url("./common/common.scss");


html {
  /* ===== Gold-on-black luxury theme (Coternalx Labs) ===== */
  --primary: #EFC02A;
  --gold: #EFC02A;
  --gold-light: #FDF2D3;
  --gold-deep: #AB8508;
  --gold-grad: linear-gradient(135deg, #FDF2D3 0%, #F2C22E 48%, #AB8508 100%);
  --navbar: #fff;
  --bg: #101010;            /* panel / glass base */
  --page: #000000;          /* pure-black page */
  --border: rgba(255,255,255,.08);
  --panel-border: rgba(239,192,42,.18);
  --labelColor: #8b8b93;
  --gray: #9a9aaf;
  --tip: #99A1B7;
  --ft: #8a8a8a;
  --input: #1a1a1a;
  --hover: #0f0f12;
}

#app {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: var(--page);
  color: #f1f1f1;
}

div {
  box-sizing: border-box;
}

/* ===== Glass card ===== */
.ant-card {
  border-radius: 16px !important;
  margin-bottom: 15px !important;
  background: linear-gradient(160deg, rgba(255,255,255,.05), rgba(255,255,255,.01)) !important;
  border: 1px solid var(--panel-border) !important;
  box-shadow: 0 0 30px rgba(239,192,42,.08), inset 0 1px 0 rgba(255,255,255,.04) !important;
  backdrop-filter: blur(20px);
}

.pagination {
  padding: 15px 0;
  text-align: right;
}

.ant-card-head {
  border-bottom: 0 !important;
}

.ant-card-head-title {
  height: 70px;
  padding: 0 !important;
  font-weight: bold !important;
  display: flex !important;
  align-items: center;
  color: #fff;
}

.ant-card-body {
  padding-top: 0 !important;
  color: #fff !important;
}

.ant-form-item-label > label {
  color: #fff !important;
}

/* ===== Inputs ===== */
.ant-input {
  width: 100%;
  color: #fff !important;
  border-radius: 8px !important;
  background-color: var(--input) !important;
  border: 1px solid var(--panel-border) !important;

  &::-webkit-input-placeholder {
    color: var(--labelColor) !important;
    font-size: 12px;
  }
}

.ant-select-selection {
  background-color: var(--input) !important;
  border: 1px solid var(--panel-border) !important;
}

.ant-select-selection-selected-value {
  color: #fff;
  font-size: 14px;
}

.ant-input-password-icon {
  color: var(--ft);
}

.ant-select-arrow {
  color: var(--gold) !important;
}

/* ===== Modal ===== */
.ant-modal-header {
  background-color: var(--bg) !important;
  color: #fff !important; 
  border-bottom: 0 !important;
}

.ant-modal-title {
  background-color: var(--bg) !important;
  color: var(--gold) !important; 
  font-size: 24px !important;
  font-weight: bold !important;
  line-height: 40px !important;
}

.ant-modal-content {
  background-color: var(--bg) !important;
  border: 1px solid var(--panel-border) !important;
  opacity: 1 !important;
  border-radius: 18px !important;
  color: #fff !important;
  box-shadow: 0 0 50px rgba(239,192,42,.12) !important;
}

.ant-modal-close-icon {
  color: #fff !important;
}

.terms {
  font-size: 12px;
  color: #fff;
  line-height: 12px;
}

/* ===== Select dropdown ===== */
.ant-select-dropdown {
  background-color: #161616 !important;
  color: #fff !important;
  border: 1px solid var(--panel-border) !important;
}

.ant-select-dropdown-menu-item-selected {
  background-color: rgba(239,192,42,.16) !important;
  color: var(--gold) !important;
}

.ant-select-dropdown-menu-item {
  color: #ddd !important;
}

.ant-select-dropdown-menu-item:hover {
  background-color: rgba(239,192,42,.10) !important;
  color: #fff !important;
}

.ant-dropdown-link {
  color: #fff;
}

/* ===== Primary button (gold gradient) ===== */
.ant-btn-primary {
  height: 35px !important;
  background: var(--gold-grad) !important;
  color: #1a1400 !important;
  font-weight: 700 !important;
  border-radius: 99px !important;
  border: 0 !important;
  box-shadow: 0 6px 22px rgba(239,192,42,.28) !important;
  transition: transform .25s cubic-bezier(.16,1,.3,1), box-shadow .25s;
}

.ant-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 30px rgba(239,192,42,.42) !important;
}

.ant-btn-link {
  color: var(--gold) !important;
}

/* ===== Checkbox ===== */
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--gold) !important;
  border-color: var(--gold) !important;

  &::after {
    border-color: #1a1400;
  }
}

/* ===== Progress ===== */
.ant-progress-bg {
  background-color: var(--gold) !important;
}
.ant-progress-success-bg {
  background-color: var(--gold) !important;
}

/* ===== Pagination ===== */
.ant-pagination-item {
  background-color: transparent !important;
  border-color: var(--panel-border) !important;
}
.ant-pagination-item a {
  color: var(--gray) !important;
}
.ant-pagination-item-active {
  background: var(--gold-grad) !important;
  border: 0 !important;
}
.ant-pagination-item-active a {
  color: #1a1400 !important;
  font-weight: 700 !important;
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  background-color: transparent !important;
  border-color: var(--panel-border) !important;
  color: var(--gold) !important;
}

/* ===== Table ===== */
.ant-table {
  background: transparent !important;
  color: #fff !important;
}
.ant-table-thead > tr > th {
  background: transparent !important;
  color: var(--gold) !important;
  border-bottom: 1px solid var(--panel-border) !important;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid rgba(255,255,255,.05) !important;
  color: #e8e8e8 !important;
}
.ant-table-tbody > tr:hover > td {
  background: rgba(239,192,42,.06) !important;
}
.ant-table-placeholder {
  background: transparent !important;
  color: var(--gray) !important;
}

/* ===== Radio button ===== */
.ant-radio-button-wrapper-checked {
  background: var(--gold-grad) !important;
  border-color: var(--gold) !important;
  color: #1a1400 !important;
}
.ant-radio-button-wrapper {
  color: #fff;
}

@media screen and (max-width: 576px) {
  #app {
    padding: 0;
  }

  .ant-card-head-title {
    height: auto;
    padding: 10px 0 !important;
    line-height: 40px;
  }

  .terms {
    font-size: 10px;
    line-height: 12px;
  }
}
</style>
